import Vue from 'vue';
import ActionButton from '@/components/molecules/buttons/ActionButton.vue';

Vue.component('action-button', ActionButton);